import { StyleSheet } from 'aphrodite';
import { borderColor, darkGrayFontColor } from '../../../../styles/colors';
import { BrowserMediaQueries, CssSelectors } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	anchor: {
		[BrowserMediaQueries.IE11]: {
			transform: 'translate3d(-1px,2px,0)',
		},
	},
	button: {
		opacity: 1,
		transform: 'translate3d(0,0,0)',
		transition: 'opacity 0.2s, transform 0.2s',
		...CssSelectors.allChildren(
			{
				alignItems: 'center',
				background: 'none',
				borderRadius: 20,
				boxShadow: 'none',
				display: 'flex',
				marginRight: 12,
				padding: '8px 10px',
				transform: 'translate3d(0,0,0)',
				transition: 'background 0.2s, box-shadow 0.2s, transform 0.1s',
			},
			'span'
		),
		':active': {
			...CssSelectors.allChildren(
				{
					boxShadow: `0 0 2px 1px rgba(0,0,0, 0.1) !important`,
					transform: 'translate3d(0,0,0) !important',
				},
				'span'
			),
		},
		':hover': {
			...CssSelectors.allChildren(
				{
					background: 'white',
					transform: 'translate3d(0,-1px,0)',
				},
				'span'
			),
		},
	},
	buttonText: {
		marginLeft: 6,
	},
	container: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	delete: {
		...CssSelectors.allChildren(
			{
				':hover': {
					boxShadow: `0 1px 2px 1px rgba(133,133,133, 0.4)`,
				},
			},
			'span'
		),
	},
	disabled: {
		opacity: 0.4,
		pointerEvents: 'none',
		transform: 'translate3d(-1px,1px,0)',
	},
	export: {
		...CssSelectors.allChildren(
			{
				':hover': {
					boxShadow: `0 1px 2px 1px rgba(137,201,71, 0.4)`,
				},
			},
			'span'
		),
	},
	merge: {
		...CssSelectors.allChildren(
			{
				':hover': {
					boxShadow: `0 1px 2px 1px rgba(242,182,57, 0.4)`,
				},
			},
			'span'
		),
	},
	more: {
		...CssSelectors.allChildren(
			{
				':hover': {
					boxShadow: `0 1px 2px 1px rgba(133,133,133, 0.4)`,
				},
			},
			'span'
		),
	},
	moreDropdown: {
		background: '#FFFFFF',
		border: `1px solid ${borderColor}`,
		borderRadius: 3,
		boxShadow: '0 2px 4px 0 rgba(0,0,0,0.10)',
		marginTop: 5,
	},
	moreDropdownItem: {
		':hover': {
			background: '#00000012',
		},
		alignItems: 'center',
		boxSizing: 'border-box',
		color: darkGrayFontColor,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		padding: '8px 10px',
		...CssSelectors.allChildren(
			{
				height: 18,
				width: 20,
			},
			'svg'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			'span'
		),
	},
});
